<app-kamona-custom-dialog [dialogType]="'info'" [showIconOnDesktop]="false">
	<div class="p-b-8">
		<h3 class="filter-title text-center">Performance Requirement Warning</h3>

		<div class="m-t-24">
			<p>
				By assigning this terminal to the business, you agree that this business would perform a minimum of
				<strong>{{ weeklyTarget | majorAmount | currency : '₦' }}</strong> in Withdrawal/Purchase/pos transfer transaction weekly.
			</p>
			<p *ngIf="modalData?.terminalModel?.terminalType !== 'MPOS'">
				You will be required to retrieve the terminal if it does not meet the requirement.
			</p>
			<p *ngIf="modalData?.terminalModel?.terminalType !== 'MPOS'">
				Your account may be placed on PND if you don’t meet performance requirements.
			</p>
			<div class="prompt-action-container">
				<button (click)="closeModal()" class="btn prompt-close-btn" nz-button>
					{{'moniepoint.cancel' | translate | titlecase}}
				</button>
				<button (click)="submitForm()" class="btn prompt-accept-btn btn-primary" nz-button>
					I Agree
				</button>
			</div>
		</div>
	</div>

</app-kamona-custom-dialog>
